import { environment } from '@/environments/environment'

export default [
  { name: 'getProveRules', url: `${environment.torontoApiUrl}/prove-rule`, method: 'POST' }
]